import { render, staticRenderFns } from "./Angebot.vue?vue&type=template&id=19c4f254&scoped=true&"
import script from "./Angebot.vue?vue&type=script&lang=js&"
export * from "./Angebot.vue?vue&type=script&lang=js&"
import style0 from "./Angebot.vue?vue&type=style&index=0&id=19c4f254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4f254",
  null
  
)

export default component.exports